import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class DynamicData {
  public file: string;
  public comment_it: string;
  public comment_de: string;
  public comment_en: string;
  public organizationTypeId: number;
}

@Injectable({
  providedIn: 'root'
})
export class DynamicDataService {

  private _dynamicData: DynamicData = new DynamicData();
  public dynamicDataSubject: Subject<DynamicData> = new Subject();

  constructor(private _http: HttpClient) { }

  /**
   * getDynamicData
   */
  public getDynamicData(orgId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId);
    return this._http.get<DynamicData>(environment.serverUrl + 'dynamicData/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        if (responseData.file) {
          responseData.file = environment.dynamicImageUrl + orgId + '/' + responseData.file;
        }
        const regEx = /<br ?\/?>/g;
        responseData.comment_de = (responseData.comment_de ? responseData.comment_de.replace(regEx, '\n') : '');
        responseData.comment_it = (responseData.comment_it ? responseData.comment_it.replace(regEx, '\n') : '');
        responseData.comment_en = (responseData.comment_en ? responseData.comment_en.replace(regEx, '\n') : '');
        this._dynamicData = responseData;
        this.dynamicDataSubject.next(this._dynamicData);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * submitDynamicImage
   */
  public submitDynamicImage(file: File, fileName: string, orgId: string) {
    const formData = new FormData();
    formData.append('id', orgId);
    formData.append('filename', fileName);
    formData.append('image', file, file.name);
    return this._http.post<{ fileName: string }>(
      environment.serverUrl + 'dynamicData/upload',
      formData
    ).pipe(
      map(responseData => {
        this._dynamicData.file = environment.dynamicImageUrl + orgId + '/' + responseData.fileName;
        this.dynamicDataSubject.next(this._dynamicData);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }



  /**
   * submitDynamicComments
   */
  public submitDynamicComments(commentIt: string, commentDe: string, commentEn: string, orgId: string) {
    return this._http.post<void>(
      environment.serverUrl + 'dynamicData/insertComment',
      { id: orgId, 'comment_it': commentIt, 'comment_de': commentDe , 'comment_en': commentEn }
    ).pipe(
      map(() => {
        this._dynamicData.comment_de = commentDe;
        this._dynamicData.comment_it = commentIt;
        this.dynamicDataSubject.next(this._dynamicData);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * deleteImage
   */
  public deleteImage(orgId: string) {
    return this._http.post<void>(
      environment.serverUrl + 'dynamicData/removeFile',
      { id: orgId }
    ).pipe(
      map(() => {
        this._dynamicData.file = null;
        this.dynamicDataSubject.next(this._dynamicData);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
